import type { ReactNode } from "react"

import type { SX } from "../../theme"
import styles from "./Form.module.css"

export interface FormProps {
  children?: ReactNode
  sx?: SX
  onSubmit: () => void
}

export function Form(props: FormProps) {
  const { children, sx, onSubmit } = props

  return (
    <form
      className={styles.root}
      style={sx}
      onSubmit={(evt) => {
        evt.preventDefault()
        onSubmit()
      }}
    >
      {children}
    </form>
  )
}
